import { render, staticRenderFns } from "./orderItemNCRPopover.vue?vue&type=template&id=7e8fcc4c&"
import script from "./orderItemNCRPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemNCRPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports